<template>
  <div class="shipments-page">
    <div class="vx-row">
      <div class="vx-col">
        <div class="page-title p-2 mb-4">
          <div class="vx-col w-full flex items-center data-list-btn-container">
            <div :style="$route.query.tab === tab ? 'background: #1C5BFE; color: white' : ''" class="relative vx-row m-2 py-2 pl-4 pr-5 cursor-pointer d-theme-dark-bg rounded-md hover:shadow-drop"
              v-for="tab in tabs" :key="tab.index" @click="changeTabFilter(tab)">
              <div class="text-sm capitalize">{{$t(tab)}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <table-filter class="mb-4" :filters="filters" :statusFilters="activeTab == 0 ? orderStatusFilters : returnStatusFilters" @changeFilter="changeFilter" @filterValue="filterValue = $event"/>
    
    <shipblu-table
      :sst="true" 
      v-model="selected" 
      multiple 
      orders
      @keyup.enter.native="handleSearchAllOrders" 
      @search="handleSearchAllOrders"
      advancedSearch
      :searchCriteria="searchCriteria"
      @selectedCriteria="selectedCriteria = $event"
      :data="shipments"
      :tableLoader="tableLoader"
    >
      <template slot="header">
        <div class="flex flex-wrap items-center gap-3 whitespace-nowrap">
          <export-button></export-button>
          <print-label-button :selected="selected"></print-label-button>
        </div>
      </template>
      <template slot="thead">
        <shipblu-th>{{$t('Tracking No.')}}</shipblu-th>
        <shipblu-th>{{$t('Merchant')}}</shipblu-th>
        <shipblu-th>{{$t('Customer')}}</shipblu-th>
        <shipblu-th>{{$t('Zone')}}</shipblu-th>
        <shipblu-th>{{$t('Address')}}</shipblu-th>
        <shipblu-th>{{$t('Estimated Delivery Date')}}</shipblu-th>
        <shipblu-th>{{$t('Packages')}}</shipblu-th>
        <shipblu-th>{{$t('Package Size')}}</shipblu-th>
        <shipblu-th>{{$t('Status')}}</shipblu-th>
      </template>
      <template slot-scope="{ data }">
        <shipblu-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" :color="`${getStyle(data[indextr])}`" viewInPanel @click="viewOrder(data[indextr])">
          <shipblu-td class="sm:hidden block col-span-2 p-0 order-3">
            <!-- line -->
            <p style="background-color: #DCDCDC;height: 1px;"></p>
          </shipblu-td>

          <shipblu-td :data="data[indextr].tracking_number" class="text-left sm:order-3 order-13">
            <div class="flex sm:static absolute top-3 gap-2 items-start justify-start transform-50" v-on:click.stop>
              <p class="sm:text-base text-lg flex gap-1 items-start justify-center">
                <span class="sm:order-2 order-1">{{ data[indextr].tracking_number }}</span>
                <shipblu-icon @click.stop.prevent="common.copied(data[indextr].tracking_number)" iconLibrary="material" iconClass="text-grey hover:text-primary text-xl cursor-pointer sm:order-1 order-2" iconName="content_copy"></shipblu-icon>
              </p>
            </div>
          </shipblu-td> 

          <shipblu-td class="order-4" :data="data[indextr].merchantName">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Merchant')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].merchant.name}}</p>
          </shipblu-td>

          <shipblu-td class="order-5" :data="data[indextr].customerName">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Customer')}}</p>
            <p class="sm:text-base text-sm">{{data[indextr].customer.full_name}}</p>
          </shipblu-td>

          <shipblu-td class="order-6" :data="data[indextr].zone">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Zone')}}</p>
            <p class="sm:text-base text-sm">{{$t(data[indextr].customer.address.zone.name) }} / {{ $t(data[indextr].customer.address.zone.city.name)}}</p>
          </shipblu-td>

          <shipblu-td class="order-7" :data="data[indextr].loaction">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Address')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].customer.address.line_1 }}</p>
          </shipblu-td>

          <shipblu-td class="order-8" :data="data[indextr].estimatedDate">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Estimated Delivery Date')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].estimated_date }}</p>
          </shipblu-td>

          <shipblu-td class="order-10" :data="data[indextr].packages">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Packages')}}</p>
            <p class="sm:text-base text-sm">{{ data[indextr].packages.length }}</p>
          </shipblu-td>

          <shipblu-td class="order-11" :data="data[indextr].packages">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Package Size')}}</p>
            <p v-for="packageItem in data[indextr].packages" :key="packageItem.index" class="sm:text-base text-sm">
              {{packageItem.package.package_size.short_code}}
            </p>
          </shipblu-td>

          <shipblu-td class="order-9" :data="data[indextr].status" style="white-space: nowrap;">
            <p class="sm:hidden block text-secondary text-sm mb-2">{{$t('Status')}}</p>
            <div class="flex" style="width: fit-content;" @click="removeAttribute($event), openNotificationFailureData(data[indextr])">
              <span class="capitalize border border-solid rounded-4xl px-5 py-1.5 leading-none sm:text-sm text-xs text-white" :style="`background-color: ${getStyle(data[indextr])}`">{{ $t(getStatusLabel(data[indextr])) }}</span>
            </div>
          </shipblu-td>
        </shipblu-tr>
      </template>
    </shipblu-table>
    <shipblu-cursor-pagination :maximumItems="maximumItems" :paginationObj="paginationObj" @changePageSize="changePageSize" @changePageNumber="changePageNumber($event)" />
    <order-view-panel :orderDataInfo="orderDataInfo" :showPanel="showPanel"></order-view-panel>
  </div>
</template>

<script>
import common from '@/assets/utils/common'
import {sendRequest} from '../../http/axios/requestHelper.js'
import ShipbluTable from '../../layouts/components/NewShipBluTable.vue'
import ShipbluTr from '../../layouts/components/ShipBluTr.vue'
import ShipbluTh from '../../layouts/components/ShipBluTh.vue'
import ShipbluTd from '../../layouts/components/ShipBluTd.vue'
import ExportButton from './components/ExportButton.vue'
import PrintLabelButton from './components/PrintLabelButton.vue'
import TableFilter from '../merchant/components/TableFilter.vue'
import ShipbluCursorPagination from '../../layouts/components/ShipbluCursorPagination.vue'
import OrderViewPanel from '../merchant/components/OrderViewPanel.vue'

export default {
  data () {
    return {
      common,
      tabs: ['Orders', 'RTOs', 'Returns'],
      tabsDic: {'0': 'Orders', '1': 'RTOs', '2': 'Returns'},
      tabsNameDic: {'Orders': 0, 'RTOs': 1, 'Returns': 2},
      activeTab: 0,
      localStorage,
      maximumItems: localStorage.getItem('maxItems') ? Number(localStorage.getItem('maxItems')) : process.env.VUE_APP_MAXIMUM_ITEMS_TABLE,
      warehousesDic: {},
      paginationObj: {
        currentPage: 1,
        currentCursor: '',
        next: null,
        previous: null
      },
      selected: [],
      shipments: [],
      filters: [],
      orderStatusFilters: [
        {
          name: 'All',
          value: 'all',
          color: '#1C5BFE'
        },
        {
          name: 'Created',
          value: 'created'
        },
        {
          name: 'Pickup Requested',
          value: 'pickup_requested'
        },
        {
          name: 'Out For Pickup',
          value: 'out_for_pickup'
        },
        {
          name: 'Picked Up',
          value: 'picked_up'
        },
        {
          name: 'Pickup Rescheduled',
          value: 'pickup_rescheduled'
        }
      ],
      returnStatusFilters: [
        {
          name: 'All',
          value: 'all',
          color: '#F58231'
        },
        {
          name: 'In Transit',
          value: 'in_transit'
        },
        {
          name: 'Return Rescheduled',
          value: 'return_rescheduled'
        },
        {
          name: 'Out For Return',
          value: 'out_for_return'
        },
        {
          name: 'Returned',
          value: 'returned'
        }
      ],
      searchAllOrdersVal: '',
      searchInProgress: false,
      searchedValue: ' ',
      tableLoader: false,
      selectedCriteria: {},
      searchCriteria: [
        {
          label: 'Tracking No.',
          value: 'tracking_number'
        },
        {
          label: 'Reference No.',
          value: 'merchant_order_reference'
        },
        {
          label: 'Phone No.',
          value: 'phone'
        }
      ],
      showPanel: false,
      orderDataInfo: {}
    }
  },
  watch: {
    '$route.query.tab' () {
      this.filters = []
      this.selected = []
      this.activeTab = this.tabsNameDic[this.$route.query.tab]
      this.loadDeliveryOrders()
    },
    '$route.params.warehouseID' () {
      this.searchAllOrdersVal = ''
      this.maximumItems = process.env.VUE_APP_MAXIMUM_ITEMS_TABLE
      this.filters = []
      this.selected = []
      this.activeTab = this.$route.query.tab ? this.tabsNameDic[this.$route.query.tab] : '0'
    },
    activeTab () {
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: this.tabsDic[this.activeTab]
        }
      }).catch(() => {})
    },
    selected () {
      this.$emit('selected', this.selected)
    },
    '$route.query.order' (val) {
      if (val) {
        this.showPanel = true
      } else {
        this.loadDeliveryOrders(this.paginationObj.currentCursor)
        this.showPanel = false
      }
    }
  },
  methods: {
    viewOrder (data) {
      this.orderDataInfo = data
      this.$router.push({
        query: {
          ...this.$route.query,
          order: data.id
        }
      }).catch(() => {})
    },
    openNotificationFailureData (order) {
      common.openNotificationFailureData(this, order)
    },
    removeAttribute (event) {
      event.preventDefault()
    },
    changePageNumber (val) {
      this.paginationObj.currentPage = val === 'next' ? this.paginationObj.currentPage + 1 : this.paginationObj.currentPage - 1
      this.loadDeliveryOrders(this.paginationObj[val])
    },
    changePageSize (val) {
      localStorage.setItem('maxItems', val)
      this.maximumItems = val
      this.loadDeliveryOrders()
    },
    changeTabFilter (tab) {
      this.activeTab = this.tabsNameDic[tab]
      this.$router.push({
        query: {
          tab: this.tabsDic[this.activeTab],
          filter: this.filters
        }
      }).catch(() => {})
    },
    changeFilter () {
      const filtersTemp = this.filters
      this.filters = []
      filtersTemp.forEach(item => {
        this.filters.push(item)
      })
      this.filters.includes(this.filterValue) ? this.filters.splice(this.filters.indexOf(this.filterValue), 1) : this.filters.push(this.filterValue)
      if (this.filterValue === 'all') {
        this.filters = []
      }
      this.$router.push({
        query: {
          tab: this.$route.query.tab,
          filter: this.filters
        }
      }).catch(() => {})
      this.loadDeliveryOrders()
    },
    handleSearchAllOrders (search) {
      this.searchAllOrdersVal = search.target && search.target !== null ? search.target.value : search
      return common.manageSearch(search, this.loadOrdersSearch)
    },
    loadOrdersSearch () {
      if (this.searchInProgress || this.searchedValue === this.searchAllOrdersVal) {
        return
      }
      this.loadDeliveryOrders()
    },
    formatWarehouses (warehouses) {
      warehouses.forEach(warehouse => {
        this.warehousesDic[warehouse.code] = warehouse.id
      })
    },
    loadDeliveryOrders (cursorVal) {
      if (!cursorVal) this.paginationObj.currentPage = 1
      this.searchInProgress = true
      this.tableLoader = true
      this.searchAllOrdersVal = this.searchAllOrdersVal.replaceAll('#', '%23')
      const query = `cursor=${cursorVal ? cursorVal : ''}&limit=${this.maximumItems}&&${this.selectedCriteria.value ? this.selectedCriteria.value : this.searchCriteria[0].value}=${this.searchAllOrdersVal}`
      const orderStatus = `&inbound_warehouse=${this.warehousesDic[this.$route.params.warehouseID]}&status=${this.filters.length > 0 ? this.filters : 'created,pickup_requested,out_for_pickup,picked_up,pickup_rescheduled'}`
      const rtoStatus = `&inbound_warehouse=${this.warehousesDic[this.$route.params.warehouseID]}&rto_requested=true&status=${this.filters.length > 0 ? this.filters : 'in_transit,out_for_return,returned,return_rescheduled'}`
      const returnStatus = `&outbound_warehouse=${this.warehousesDic[this.$route.params.warehouseID]}&status=${this.filters.length > 0 ? this.filters : 'in_transit,out_for_return,returned,return_rescheduled'}`
      sendRequest(true, false, this, `api/v1/${this.activeTab === '2' || this.activeTab === 2 ? 'returns' : 'delivery-orders'}/?${query}${this.activeTab === '0' || this.activeTab === 0 ? orderStatus : this.activeTab === '1' || this.activeTab === 1 ? rtoStatus : returnStatus}`, 'get', null, true, 
        (response) => {
          this.selected = []
          this.shipments = response.data.results
          this.tableLoader = false
          this.paginationObj.currentCursor = cursorVal ? cursorVal : ''
          this.paginationObj.next = response.data.next && new URL(response.data.next).searchParams.get('cursor')
          this.paginationObj.previous = response.data.previous && new URL(response.data.previous).searchParams.get('cursor')
          this.searchedValue = this.searchAllOrdersVal
        }
      )
      this.searchInProgress = false
    },
    getStyle (data) {
      return common.getOrderStatusColor(data.status)
    },
    getOrderStatusColor (order) {
      return common.getOrderStatusColor(this.getStatusLabel(order))
    },
    getStatusLabel (order) {
      return common.getStatusLabel(order, this.$store.state.AppActiveUser.userRole)
    }
  },
  components: {
    ExportButton,
    PrintLabelButton,
    ShipbluTable,
    ShipbluTr,
    ShipbluTh,
    ShipbluTd,
    TableFilter,
    ShipbluCursorPagination,
    OrderViewPanel
  },
  mounted () {
    this.$emit('setAppClasses', 'shipment-page')
  },
  created () {
    this.activeTab = this.$route.query.tab ? this.tabsNameDic[this.$route.query.tab] : '0'
    this.filters = this.$route.query.filter ? typeof (this.$route.query.filter) === 'string' ? Array(this.$route.query.filter) : this.$route.query.filter : []
    common.manageLoadWarehouses(this.formatWarehouses, this)
    if (this.$route.query.order) {
      this.showPanel = true
    } else {
      this.showPanel = false
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
.con-pagination-table{
  display: none;
}
#order-label-print{
  display: none;
  visibility: hidden;
}
</style>